const nascimento = {
  'NOME DO REGISTRADO': 1,
  'DATA DE NASCIMENTO': 1,
  'HORA DO NASCIMENTO DO REGISTRADO': 1,
  'SEXO DO REGISTRADO': 1,
  'SEXO DO NASCIDO': 1,
  'GENITORES': 1,
  'GENITOR': 1,
  'FILIACAO': 1,
  'MÃE': 1,
  'PAI': 1,
  'LOCAL DA OCORRÊNCIA': 1,
  'LOCAL DO NASCIMENTO': 1,
  'NATURALIDADE DO REGISTRADO': 1,
  'GÊMEOS': 1,
  'PARTES': 2,
  'PARTE': 2,
  'COMPLEMENTOS': 2,
  'GESTAÇÃO E PARTO': 2,
  'RECÉM NASCIDO': 2,
  'DATA DO REGISTRO': 3
}

const obito = {
  'CPF DO REGISTRADO': 1,
  'CPF DO FALECIDO': 1,
  'NOME DO REGISTRADO': 1,
  'NOME DO FALECIDO': 1,
  'SEXO DO REGISTRADO': 1,
  'SEXO DO FALECIDO': 1,
  'COR DA PELE': 1,
  'ESTADO CIVIL': 1,
  'NACIONALIDADE': 1,
  'PROFISSÃO': 1,
  'UF': 1,
  'NATURALIDADE': 1,
  'ENDEREÇO': 1,
  'GENITOR': 1,
  'GENITORES': 1,
  'FILIACAO': 1,
  'MÃE': 1,
  'PAI': 1,
  'DATA DE FALECIMENTO': 2,
  'HORA DO FALECIMENTO': 2,
  'LOCAL DE OCORRÊNCIA': 2,
  'CAUSAS DE ÓBITO': 2,
  'CAUSA MORTE PARTE 1': 2,
  'CAUSA MORTE PARTE I': 2,
  'CAUSA MORTE PARTE 2': 2,
  'CAUSA MORTE PARTE II': 2,
  'TIPO DE MORTE': 2,
  'NOME DO MÉDICO': 2,
  'ATESTANTE PRIMÁRIO': 2,
  'SEGUNDO MÉDICO': 2,
  'ATESTANTE SECUNDÁRIO': 2,
  'SEPULTAMENTO': 2,
  'FUNERÁRIA': 2,
  'DOCUMENTOS': 3,
  "RG": 3,
  "CTPS": 3,
  "RNE": 3,
  "PASSAPORTE": 3,
  "TITULO_DE_ELEITOR": 3,
  "CERT_DE_RESERVISTA": 3,
  "CERT_DE_NASCIMENTO": 3,
  "RIC": 3,
  "NIT": 3,
  "CNH": 3,
  "BENEFICIO_PREVIDENCIARIO": 3,
  "CARTEIRA_DE_MARITIMO": 3,
  "DOC_ESTRANGEIRO": 3,
  "NAO_IDENTIFICADO": 3,
  "TITULO DE ELEITOR": 3,
  "CERTIFICADO DE RESERVISTA": 3,
  "CERTIDÃO  DE NASCIMENTO": 3,
  "BENEFICIO PREVIDENCIARIO": 3,
  "CARTEIRA DE MARITIMO": 3,
  "DOCUMENTO ESTRANGEIRO": 3,
  "NAO IDENTIFICADO": 3,
  'FILHOS': 3,
  'FILHO': 3,
  'DECLARANTE': 3,
  'PARTES': 3,
  'NOME DA PARTE': 3,
  'INFORMAÇÕES ADICIONAIS': 3,
  'DATA DO REGISTRO': 4
}

const casamento = {
  'NOME DO CÔNJUGE 1': 1 ,
  'NOVO NOME DO CÔNJUGE 1': 1 ,
  'CPF DO CÔNJUGE 1': 1 ,
  'SEXO DO CÔNJUGE 1': 1 ,
  'DATA DE NASCIMENTO DO CÔNJUGE 1': 1 ,
  'PAI DO CÔNJUGE 1': 1 ,
  'MÃE DO CÔNJUGE 1': 1 ,
  'NOME DO PAI DO CÔNJUGE 1': 1 ,
  'SEXO DO PAI DO CÔNJUGE 1': 1 ,
  'NOME DA MÃE DO CÔNJUGE 1': 1 ,
  'SEXO DA MÃE DO CÔNJUGE 1': 1 ,
  'CÓDIGO DA OCUPAÇÃO DECLARADA DO CÔNJUGE 1': 1 ,
  'PAIS DE NASCIMENTO DO CÔNJUGE 1': 1 ,
  'NACIONALIDADE DO CÔNJUGE 1': 1 ,
  'CÓDIGO IBGE DO MUNICÍPIO DE NATURALIDADE DO CÔNJUGE 1': 1 ,
  'TEXTO LIVRE DO MUNICÍPIO DE NATURALIDADE DO CÔNJUGE 1': 1 ,
  'CÓDIGO IBGE DO MUNICÍPIO DO LOGRADOURO DO CÔNJUGE 1': 1 ,
  'DOMICÍLIO ESTRANGEIRO DO CÔNJUGE 1': 1 ,
  'NOME DO CÔNJUGE 2': 2 ,
  'NOME NOME DO CÔNJUGE 2': 2 ,
  'CPF DO CÔNJUGE 2': 2 ,
  'SEXO DO CÔNJUGE 2': 2 ,
  'DATA DE NASCIMENTO DO CÔNJUGE 2': 2,
  'NOME DO PAI DO CÔNJUGE 2': 2 ,
  'SEXO DO PAI DO CÔNJUGE 2': 2 ,
  'NOME DA MÃE DO CÔNJUGE 2': 2 ,
  'SEXO DA MÃE DO CÔNJUGE 2': 2 ,
  'CÓDIGO OCUPAÇÃO DO CÔNJUGE 2': 2 ,
  'PAIS DE NASCIMENTO DO CÔNJUGE 2': 2 ,
  'NACIONALIDADE DO CÔNJUGE 2': 2 ,
  'CÓDIGO IBGE DO MUNICÍPIO DE NATURALIDADE DO CÔNJUGE 2': 2 ,
  'CÓDIGO IBGE DO MUNICÍPIO DO LOGRADOURO DO CÔNJUGE 2': 2 ,
  'DOMICÍLIO ESTRANGEIRO DO CÔNJUGE 2': 2 ,
  'DATA DO CASAMENTO': 3,
  'REGIME DO CASAMENTO': 3,
  'REGIME DE BENS': 3,
  'DATA DO REGISTRO': 4,
}

export default { nascimento, obito, casamento }
